module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/cover_generator_manual/step1-a34ab4243e7ae857c66e395749e366ab.png";